/* Dialog Text */
import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  InteractSubContents,
  InteractSubTypeLicenses,
  Interacts,
  Interact, DodEndPointEx, DodEndPoint, ApiEndPoint,
} from '../../../api/models';
import { AdminInteractiveSubService } from "../../../api/services";
import {
  TextEditDialogData,
  TextEditDialogComponent,
} from "../../text-edit-dialog/text-edit-dialog.component";

export interface EditInteractiveSubscriptionsDialogData {
  dialogTitle: string;
  isNew: boolean;
  interactSubTypeId: number;
  interactives: Interacts[];
  endPoints: DodEndPoint[];
  apiEndPoints: ApiEndPoint[];
  interactSubTypeName: string;
  description: string;
  marketingUrl: string;
  adminInteractiveSubService: AdminInteractiveSubService;
  appliedInteractives: Interacts[];
  appliedEndPoints: DodEndPoint[];
  appliedApiEndPoints: ApiEndPoint[];
  appliedLicenses: InteractSubTypeLicenses[];
  restrictPurchaseEmails: string[];
  licenseText: string;
}

@Component({
  selector: "edit-interactive-subscription-dialog",
  styleUrls: ["edit-interactive-subscription-dialog.component.css"],
  templateUrl: "./edit-interactive-subscription-dialog.component.html",
})
export class EditInteractiveSubscriptionsDialogComponent {
  public Result: DialogResult;
  public isLoading: boolean = true;
  public ToAddEmail: string = "";

  constructor(
    public dialogRef: MatDialogRef<EditInteractiveSubscriptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: EditInteractiveSubscriptionsDialogData,
    private dialog: MatDialog
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    if (this.data.isNew) {
      this.isLoading = false;
    } else {
      this.data.adminInteractiveSubService
        .adminInteractiveSubGetInteractSubTypeInteractives(
          this.data.interactSubTypeId
        )
        .subscribe((result1) => {
          this.data.adminInteractiveSubService
            .adminInteractiveSubGetInteractSubLevels2(
              this.data.interactSubTypeId
            )
            .subscribe((result2) => {
              this.data.adminInteractiveSubService
                .adminInteractiveSubGetInteractSubTypeLicenses(
                  this.data.interactSubTypeId
                )
                .subscribe((result3) => {
                  this.data.adminInteractiveSubService
                    .adminInteractiveSubGetInteractSubTypesRestrictedUsers(
                      this.data.interactSubTypeId
                    )
                    .subscribe((result4) => {
                      this.data.adminInteractiveSubService
                        .adminInteractiveSubGetInteractSubTypeDodEndPoints(
                          this.data.interactSubTypeId
                        )
                        .subscribe((result5) => {
                          this.data.adminInteractiveSubService
                            .adminInteractiveSubGetInteractSubTypeApiEndPoints(
                              this.data.interactSubTypeId
                            )
                            .subscribe((result6) => {
                                      this.data.appliedInteractives = result1;
                                      this.data.appliedLicenses = result3;
                                      this.data.appliedEndPoints = result5;
                                      this.data.appliedApiEndPoints = result6;

                                      this.data.apiEndPoints.sort((a, b) =>
                                        a.apiEndPointPath.localeCompare(b.apiEndPointPath)
                                      );
                                      this.data.endPoints.sort((a, b) =>
                                        a.title.localeCompare(b.title)
                                      );
                                      this.data.interactives.sort((a, b) =>
                                        a.interactName.localeCompare(b.interactName)
                                      );

                                      for (var i = 0; i < result4.length; i++) {
                                        this.data.restrictPurchaseEmails.push(
                                          result4[i].emailAddress
                                        );
                                      }

                                      this.isLoading = false;
                            });
                        });
                    });
                });
            });
        });
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  isApiEndPointSelected(ep: ApiEndPoint): boolean {
    return (
      this.data.appliedApiEndPoints.find(
        (x) => x.apiEndPointId == ep.apiEndPointId
      ) != null
    );
  }

  toggleApiEndPoint(ep: ApiEndPoint) {
    let index = this.data.appliedApiEndPoints.findIndex(
      (x) => x.apiEndPointId == ep.apiEndPointId
    );
    if (index != -1) {
      this.data.appliedApiEndPoints.splice(index, 1);
    } else {
      this.data.appliedApiEndPoints.push(ep);
    }
  }

  isEndPointSelected(ep: DodEndPoint): boolean {
    return (
      this.data.appliedEndPoints.find(
        (x) => x.dodEndPointId == ep.dodEndPointId
      ) != null
    );
  }

  toggleEndPoint(ep: DodEndPoint) {
    let index = this.data.appliedEndPoints.findIndex(
      (x) => x.dodEndPointId == ep.dodEndPointId
    );
    if (index != -1) {
      this.data.appliedEndPoints.splice(index, 1);
    } else {
      this.data.appliedEndPoints.push(ep);
    }
  }

  isInteractiveSelected(interactive: Interacts): boolean {
    return (
      this.data.appliedInteractives.find(
        (x) => x.interactId == interactive.interactId
      ) != null
    );
  }

  toggleInteractive(interactive: Interacts) {
    let index = this.data.appliedInteractives.findIndex(
      (x) => x.interactId == interactive.interactId
    );
    if (index != -1) {
      this.data.appliedInteractives.splice(index, 1);
    } else {
      this.data.appliedInteractives.push(interactive);
    }
  }


  editLicense() {
    var params: TextEditDialogData = {
      title: "Add / Edit License",
      prompt: "Enter license HTML below",
      data: this.data.licenseText,
    };

    var dialogRef = this.dialog.open(TextEditDialogComponent, {
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.data.licenseText = result.ResultData;
      }
    });
  }

  addRestrictedEmail() {}

  onRemoveEmail(toRemoveEmail: string) {}
}

/* Calling Methods */
/*
  callEditInteractiveSubscriptions(params: EditInteractiveSubscriptionsDialogData) {
    var dialogRef = this.dialog.open(EditInteractiveSubscriptionsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
